import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/iblShadowDebug.fragment.js
var name, shader, iblShadowDebugPixelShader;
var init_iblShadowDebug_fragment = __esm({
  "node_modules/@babylonjs/core/Shaders/iblShadowDebug.fragment.js"() {
    init_shaderStore();
    name = "iblShadowDebugPixelShader";
    shader = `#ifdef GL_ES
precision mediump float;
#endif
varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D debugSampler;uniform vec4 sizeParams;
#define offsetX sizeParams.x
#define offsetY sizeParams.y
#define widthScale sizeParams.z
#define heightScale sizeParams.w
void main(void) {vec2 uv =
vec2((offsetX+vUV.x)*widthScale,(offsetY+vUV.y)*heightScale);vec4 background=texture2D(textureSampler,vUV);vec4 debugColour=texture2D(debugSampler,vUV);if (uv.x<0.0 || uv.x>1.0 || uv.y<0.0 || uv.y>1.0) {gl_FragColor.rgba=background;} else {gl_FragColor.rgb=mix(debugColour.rgb,background.rgb,0.0);gl_FragColor.a=1.0;}}`;
    ShaderStore.ShadersStore[name] = shader;
    iblShadowDebugPixelShader = { name, shader };
  }
});

export {
  iblShadowDebugPixelShader,
  init_iblShadowDebug_fragment
};
